module.exports = __webpack_public_path__ + "img/mo.444e223e.svg";